import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { map, Observable, of, switchMap, tap } from "rxjs";
import HttpHelper from "../helpers/http.helper";
import { AppConfigService } from "./app-config.service";

@Injectable({
    providedIn: 'root'
})
export class ImageDownloadService {
    private readonly apiUrl: string;
    
    constructor(private readonly http: HttpClient,
        private readonly sanitizer: DomSanitizer,
        private readonly appConfigService: AppConfigService) 
    {
        this.apiUrl = `${this.appConfigService.getConfig().apiUrl}`;
    }

    public getImageUrl(id: string, type: string): Observable<SafeUrl | null> {
        if (!id) {
            return of(null);
        }

        return this.download(id)
        .pipe(map(blob => this.blobToSafeUrl(blob, type)));
    }
    
    private blobToSafeUrl(blob: Blob, type: string): SafeUrl {
        const imageBlob = new Blob([blob], { type: type });
        const unsafeImg = URL.createObjectURL(imageBlob);
        return this.sanitizer.bypassSecurityTrustUrl(unsafeImg);
    }

    private download(id: string): Observable<Blob> {
      return this.http.get(`${this.apiUrl}/api/File/${id}`, 
        {
            responseType: 'blob'
        });
    }
}
